/**
 * Theme type for Dragonfruit.
 *
 * Consumers of Dragonfruit should provide a theme that matches this type.
 */
export type Theme = Record<ThemeVariables, string>;

/**
 * Theme variables for Dragonfruit.
 *
 * Variables that can be used to define a theme for Dragonfruit.
 *
 * Note(s):
 * - All variables should be prefixed with 'df-' to avoid conflicts.
 */
export enum ThemeVariables {
  primaryBackgroundColor = 'df-primary-background-color',
  // TODO(@julia-wang-ai): Migrate all styling to theme variables
}
